/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { R7aUrceniEditoraZpsDetailResponse } from '../types/R7aUrceniEditoraZpsDetail';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type R7UrceniEditoraZpsRetrieveRequest = {} | null | undefined;
export type R7UrceniEditoraZpsRetrieveResponse = R7aUrceniEditoraZpsDetailResponse;

export type R7UrceniEditoraZpsRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this urceny editor zps.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/r7_urceni_editora_zps/{id}/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_retrieve
 * tags:
 *   - r7_urceni_editora_zps
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/R7aUrceniEditoraZpsDetail'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsRetrieveOperation = ({
  id,
  ...rest
}: R7UrceniEditoraZpsRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/r7_urceni_editora_zps/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/r7_urceni_editora_zps/{id}/' };
  };

/**
 * GET /dmx-server/r7_urceni_editora_zps/{id}/
 *
 * ```yaml
 * operationId: r7_urceni_editora_zps_retrieve
 * tags:
 *   - r7_urceni_editora_zps
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/R7aUrceniEditoraZpsDetail'
 *     description: ''
 * ```
 */
export const r7UrceniEditoraZpsRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: R7UrceniEditoraZpsRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<R7aUrceniEditoraZpsDetailResponse>> => {
  const operation = r7UrceniEditoraZpsRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/r7_urceni_editora_zps/{id}/
 */
export const useR7UrceniEditoraZpsRetrieveResource = (
  query: R7UrceniEditoraZpsRetrieveQuery | null,
  useCached?: boolean,
): UseResource<R7UrceniEditoraZpsRetrieveResponse> => {
  return useResource<R7UrceniEditoraZpsRetrieveResponse>({
    path: query === null ? null : r7UrceniEditoraZpsRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
